module.exports = __webpack_public_path__ + "Server-Healthy.Ftp.2f6ef9e628976ec683c0bee6d2c2ac81.hashedasset.svg";